import { Helmet } from "react-helmet-async";
import cx from "classnames";
import { useEffect } from "react";

import { designTokensCssDecl } from "@/lib/design-token-utils";

import "./PageLayout.scss";

type PageLayoutProps = {
  title?: string;
  children?: React.ReactNode;
  className?: string;
};

const PRODUCT_NAME = "Ping Intel";

/**
 * The root layout component that should wrap all pages in the application. It
 * turns our design tokens into CSS variables and inserts them into the
 * document.
 *
 * It also provides a consistent page structure and applies all base CSS styles
 * and resets through its associated SCSS file.
 */
const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  children,
  className,
}) => {
  const fullTitle = title ? `${title} · ${PRODUCT_NAME}` : PRODUCT_NAME;
  const appliedClasses = cx("PageLayout", className);

  useEffect(() => {
    const styleId = "pingDesignTokens";
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.textContent = designTokensCssDecl;
  }, []);

  return (
    <>
      {title && (
        <Helmet>
          <title>{fullTitle}</title>
        </Helmet>
      )}
      <div className={appliedClasses}>{children}</div>
    </>
  );
};

export { PageLayout };
